import { registerEnumSet } from '@if/mui'
import { CircleStop } from 'lucide-react'

/** Custom Buydown plan lifecycle state, as the dashboard shows it. Only expired plans carry a pill today. */
export enum EPlanStatus {
  Expired = 'Expired',
}

// Registers the plan statuses as enum chips (color + icon + label) in the shared
// @if/mui enum registry, so an expired plan gets the same status pill as every
// other status surface. Load-once side-effect — imported at app bootstrap (main.tsx).
registerEnumSet(EPlanStatus, {
  [EPlanStatus.Expired]: { color: 'secondary', icon: CircleStop, labelKey: 'customBuydown.history.expired' },
})
